import { getParticipantLabel } from "Constants/constant";

export const formatAuditFieldName = (field, careSector = null) => {
  const participantLabel = getParticipantLabel(careSector, false);
  const labels = {
    worker_id: "Worker",
    pt_id: participantLabel,
    participant_id: participantLabel,
    shift_accept: "Shift Accepted",
    email: "Primary Email Address",
    user_id: "App Login User",
    participant_app_enabled: "Participant App Access",
    pt_shift_req_allow: "Participant App Shift Requests",
    shift_req_allow: "Family App Shift Requests",
    family_app_enabled: "Family App",
    family_member_emails: "Family Member Emails",
    family_member_email: "Family Member Email",
    invite_email: "Invite Sent To",
    invite_status: "Invite Status",
    app: "App",
    req_date: "Requested Date",
    service_category: "Service Category",
    roster_shift: "Roster Shift",
    shift_date: "Shift Date",
    participant: "Participant",
    service_category: "Service Category",
    location_tracking: "Worker Tracking",
    is_group_shift: "Group Shift",
    is_open_shift: "Open Shift",
    is_signature: "Participant's Signature",
    is_radius: "Enforce Distance Restriction",
    sleepover: "Sleepover Shift",
    ratio: "Ratio (Worker: Participants)",
  };

  if (labels[field]) {
    return labels[field];
  }

  return field.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
};
